module.exports = __webpack_public_path__ + "static/media/bg-image-home.93c7926d.jpg";